<template>
  <b-overlay :show="loading">
    <button
      type="button"
      class="delete button-primary ml-2 mr-2 pl-3 pr-3"
      @click="$emit('click')"
    >
      <img src="@/assets/images/icons/delete_trash_white.svg" />
      <span class="cta ml-2">
        <slot></slot>
      </span>
    </button>
    <template #overlay>
      <overlay-button></overlay-button>
    </template>
  </b-overlay>
</template>
<script>
import overlayButton from "../overlay/overlay-button.vue";
export default {
  name: "del-modal",
  components: { overlayButton },
  props: {
    disabled: {
      default: true,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
  emits: ["click"],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">

</style>